import { PersonalizationNonPaddedRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/personalizationNonPaddedRoutes";

export const StandardNoPaddingRoutes = [...PersonalizationNonPaddedRoutes];
